import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import {
  PagePerformance,
  PageScores,
  PageParticipations,
  PageQuestions,
} from '../pages/reports';

const RouteAnswers = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/performance`} />
      </Route>
      <Route exact path={`${path}/performance`}>
        <PagePerformance />
      </Route>
      <Route exact path={`${path}/scores`}>
        <PageScores />
      </Route>
      <Route exact path={`${path}/participations`}>
        <PageParticipations />
      </Route>
      <Route exact path={`${path}/questions`}>
        <PageQuestions />
      </Route>
    </Switch>
  );
};

export default RouteAnswers;
